import React, { useState } from "react";
import emailjs from "emailjs-com";

// Components

import Buttons from "../components/Buttons";
import TitleBox from "../components/TitleBox";
import BoxIcon from "../components/BoxIcon";
import Slider from "../components/Slider";
import Footer from "../components/Footer";
import BannerSlide from "../components/BannerSlide";

// Hooks

import { useMediaQuery } from "react-responsive";

// Assets

// import HeroImage from "../assets/images/hero-img.png";

import Activity from "../assets/icons/ic-activity.png";
import Bed from "../assets/icons/ic-bed.png";
import DeathBenefit from "../assets/icons/ic-death-benefit.png";
import Dental from "../assets/icons/ic-dental.png";
import Health from "../assets/icons/ic-health.png";
import Shield from "../assets/icons/ic-shield.png";

import CLogo_1 from "../assets/images/client-logo-1.png";
import CLogo_2 from "../assets/images/client-logo-2.png";
import CLogo_3 from "../assets/images/client-logo-3.png";
import CLogo_4 from "../assets/images/client-logo-4.png";
import CLogo_5 from "../assets/images/client-logo-5.png";

// import { Facebook, Instagram, Youtube, Twitter } from "react-feather";

// CSS

import "./css/Home.scss";

const Hero = ({ args }) => {
  return (
    <div
      className="segment-1"
      style={{
        height: args.height - 75,
        width: args.width,
      }}
    >
      <BannerSlide />
    </div>
  );
};

const WhatWeOffer = ({ args }) => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1025px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  return (
    <>
      {isMobile && (
        <div
          className="segment-2"
          style={{
            width: args.width,
          }}
        >
          <TitleBox title={"What We Offer"} />
          <div className="services-grid">
            <div className="row">
              <BoxIcon
                objContainer={{
                  icon: Shield,
                  title: "Preventive Healthcare",
                  text: `Measures taken to prevent illness/disease by 
            providing medical service such as regular medical 
            check-up (CBC, Urinalysis, Fecalysis, 
            Chest X-Ray, Physical Examination)`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: Health,
                  title: "Out-Patient Consultation",
                  text: `A patient whose treatment does not 
            require an overnight stay in a hospital or clinic.`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: Activity,
                  title: "Emergency Care Treatment",
                  text: `A sudden serious situation or occurrence that happens 
       unexpectedly and demands immediate action. 
       It could be a life threatening situation
        that can cause permanent disability.`,
                }}
              />
            </div>

            <div className="row">
              <BoxIcon
                objContainer={{
                  icon: Bed,
                  title: "Hospital Confinement",
                  text: `The period in a healthcare facility (hospital)
  that begins with a patient’s admission
  and ends with discharge.`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: Dental,
                  title: "Dental Care",
                  text: `Is the maintenance of keeping the oral cavity 
  in order to prevent dental caries, gum disease
   & other dental disorders`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: DeathBenefit,
                  title: "Death Benefit",
                  text: `The monetary benefit entitled to a 
  beneficiary upon the death of the insured.`,
                }}
              />
            </div>
          </div>
        </div>
      )}
      {isTablet && (
        <div
          className="segment-2"
          style={{
            width: args.width,
          }}
        >
          <TitleBox title={"What We Offer"} />

          <div className="services-grid">
            <div className="row">
              <BoxIcon
                objContainer={{
                  icon: Shield,
                  title: "Preventive Healthcare",
                  text: `Measures taken to prevent illness/disease by 
            providing medical service such as regular medical 
            check-up (CBC, Urinalysis, Fecalysis, 
            Chest X-Ray, Physical Examination)`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: Health,
                  title: "Out-Patient Consultation",
                  text: `A patient whose treatment does not 
            require an overnight stay in a hospital or clinic.`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: Activity,
                  title: "Emergency Care Treatment",
                  text: `A sudden serious situation or occurrence that happens 
       unexpectedly and demands immediate action. 
       It could be a life threatening situation
        that can cause permanent disability.`,
                }}
              />
            </div>

            <div className="row">
              <BoxIcon
                objContainer={{
                  icon: Bed,
                  title: "Hospital Confinement",
                  text: `The period in a healthcare facility (hospital)
  that begins with a patient’s admission
  and ends with discharge.`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: Dental,
                  title: "Dental Care",
                  text: `Is the maintenance of keeping the oral cavity 
  in order to prevent dental caries, gum disease
   & other dental disorders`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: DeathBenefit,
                  title: "Death Benefit",
                  text: `The monetary benefit entitled to a 
  beneficiary upon the death of the insured.`,
                }}
              />
            </div>
          </div>
        </div>
      )}
      {isDesktop && (
        <div
          className="segment-2"
          style={{
            height: args.height,
            width: args.width,
          }}
        >
          <TitleBox title={"What We Offer"} />

          <div className="services-grid">
            <div className="row">
              <BoxIcon
                objContainer={{
                  icon: Shield,
                  title: "Preventive Healthcare",
                  text: `Measures taken to prevent illness/disease by 
            providing medical service such as regular medical 
            check-up (CBC, Urinalysis, Fecalysis, 
            Chest X-Ray, Physical Examination)`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: Health,
                  title: "Out-Patient Consultation",
                  text: `A patient whose treatment does not 
            require an overnight stay in a hospital or clinic.`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: Activity,
                  title: "Emergency Care Treatment",
                  text: `A sudden serious situation or occurrence that happens 
       unexpectedly and demands immediate action. 
       It could be a life threatening situation
        that can cause permanent disability.`,
                }}
              />
            </div>

            <div className="row">
              <BoxIcon
                objContainer={{
                  icon: Bed,
                  title: "Hospital Confinement",
                  text: `The period in a healthcare facility (hospital)
  that begins with a patient’s admission
  and ends with discharge.`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: Dental,
                  title: "Dental Care",
                  text: `Is the maintenance of keeping the oral cavity 
  in order to prevent dental caries, gum disease
   & other dental disorders`,
                }}
              />
              <BoxIcon
                objContainer={{
                  icon: DeathBenefit,
                  title: "Death Benefit",
                  text: `The monetary benefit entitled to a 
  beneficiary upon the death of the insured.`,
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const News = ({ args }) => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1025px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  return (
    <>
      {isMobile && (
        <div
          className="segment-3"
          style={{
            width: args.width,
          }}
        >
          <TitleBox title={"Latest News"} />
          <Slider />
        </div>
      )}
      {isTablet && (
        <div
          className="segment-3"
          style={{
            width: args.width,
          }}
        >
          <TitleBox title={"Latest News"} />
          <Slider />
        </div>
      )}
      {isDesktop && (
        <div
          className="segment-3"
          style={{
            height: args.height / 1.5,
            width: args.width,
          }}
        >
          <TitleBox title={"Latest News"} />
          <Slider />
        </div>
      )}
    </>
  );
};

const ContactUs = ({ args }) => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1025px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  function validateEmail(email) {
    const res =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return res.test(String(email).toLowerCase());
  }

  function sendEmail(e) {
    e.preventDefault();

    args.setActivateToast(true);

    // Check if the user is a bot

    if (document.getElementById("txtHp").value !== "") {
      return;
    }

    // Validate

    if (document.getElementById("txtName").value === "") {
      args.setToastProps({
        message: "Please enter your full name.",
        style: "error",
      });
      return;
    } else if (document.getElementById("txtMsg").value === "") {
      args.setToastProps({
        message: "Please tell us your message.",
        style: "error",
      });
      return;
    } else if (document.getElementById("txtContactNo").value === "") {
      args.setToastProps({
        message: "Please enter your contact number.",
        style: "error",
      });
      return;
    } else {
      if (document.getElementById("txtEmail").value === "") {
        args.setToastProps({
          message: "Please enter your e-mail address.",
          style: "error",
        });
        return;
      } else {
        if (!validateEmail(document.getElementById("txtEmail").value)) {
          args.setToastProps({
            message: "Please enter a valid e-mail address.",
            style: "error",
          });
          return;
        }
      }
    }

    emailjs
      .sendForm(
        "service_ioicoa7",
        "template_oipx6r9",
        e.target,
        "user_CRUbPL4RXgAq0YDDqftS1"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    args.setToastProps({
      message: "Your e-mail has been successfully sent!",
      style: "success",
    });
    e.target.reset();
  }

  return (
    <>
      {isMobile && (
        <div
          className="segment-5"
          style={{
            width: args.width,
          }}
        >
          <div className="col col-1">
            <div className="title">Get in touch with us.</div>

            <div className="label">Address</div>
            <div className="text">
              LSS Building, #107 13th Ave., Brgy. Socorro, Cubao, Quezon City,
              Philippines
            </div>

            <div className="label">Phone</div>
            <div className="text">
              <ul>
                <li>+632 8912 4196</li>
                <li>+632 8913 8893</li>
                <li>+632 8912 4132</li>
              </ul>
            </div>
          </div>
          <div className="col col-2">
            <form method="POST" id="contactForm" onSubmit={(e) => sendEmail(e)}>
              <div className="label">Name</div>
              <input id="txtName" type="text" name="name" placeholder="Name" />
              <input type="text" id="txtHp" />
              <div className="label">Email</div>
              <input
                id="txtEmail"
                type="text"
                name="email"
                placeholder="Email"
              />
              <div className="label">Contact Number</div>
              <input
                id="txtContactNo"
                type="text"
                name="phone"
                placeholder="Contact Number"
              />
              <div className="label">Message</div>
              <textarea id="txtMsg" name="message" rows="2"></textarea>
              <Buttons
                text="Send Message"
                color="secondary"
                type="submit"
                style={{
                  marginLeft: "auto",
                  marginTop: "2.5%",
                }}
              />
            </form>
          </div>
          <div className="col col-3">
            {/* <div className='label'>Social</div>
            <div className='text-icon'>
              <Facebook />
              <Twitter />
              <Instagram />
              <Youtube />
            </div> */}
          </div>
        </div>
      )}
      {isTablet && (
        <div
          className="segment-5"
          style={{
            width: args.width,
          }}
        >
          <div className="col col-1">
            <div className="title">Get in touch with us.</div>

            <div className="label">Address</div>
            <div className="text">
              LSS Building, #107 13th Ave., Brgy. Socorro, Cubao, Quezon City,
              Philippines
            </div>

            <div className="label">Phone</div>
            <div className="text">
              <ul>
                <li>+632 8912 4196</li>
                <li>+632 8913 8893</li>
                <li>+632 8912 4132</li>
              </ul>
            </div>
          </div>
          <div className="col col-2">
            <form method="POST" id="contactForm" onSubmit={(e) => sendEmail(e)}>
              <div className="label">Name</div>
              <input id="txtName" type="text" name="name" placeholder="Name" />
              <input type="text" id="txtHp" />
              <div className="label">Email</div>
              <input
                id="txtEmail"
                type="text"
                name="email"
                placeholder="Email"
              />
              <div className="label">Contact Number</div>
              <input
                id="txtContactNo"
                type="text"
                name="phone"
                placeholder="Contact Number"
              />
              <div className="label">Message</div>
              <textarea id="txtMsg" name="message" rows="2"></textarea>
              <Buttons
                text="Send Message"
                color="secondary"
                type="submit"
                style={{
                  marginLeft: "auto",
                  marginTop: "2.5%",
                }}
              />
            </form>
          </div>
          <div className="col col-3">
            {/* <div className='label'>Social</div>
            <div className='text-icon'>
              <Facebook />
              <Twitter />
              <Instagram />
              <Youtube />
            </div> */}
          </div>
        </div>
      )}
      {isDesktop && (
        <div
          className="segment-5"
          style={{
            height: args.height / 1.5,
            width: args.width,
          }}
        >
          <div className="col col-1">
            <div className="title">Get in touch with us.</div>

            <div className="label">Address</div>
            <div className="text">
              LSS Building, #107 13th Ave., Brgy. Socorro, Cubao, Quezon City,
              Philippines
            </div>

            <div className="label">Phone</div>
            <div className="text">
              <ul>
                <li>+632 8912 4196</li>
                <li>+632 8913 8893</li>
                <li>+632 8912 4132</li>
              </ul>
            </div>
            <div className="text">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d354.6360862271403!2d121.05873063130804!3d14.617182064960764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397b7eb2cfc3db5%3A0xec989f356eab4fad!2sGetwell%20Health%20Systems%2C%20Inc!5e0!3m2!1sen!2shk!4v1645431739024!5m2!1sen!2shk"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: 10 }}
                loading="lazy"
              ></iframe>
            </div>
          </div>
          <div className="col col-2">
            <form method="POST" id="contactForm" onSubmit={(e) => sendEmail(e)}>
              <div className="label">Name</div>
              <input id="txtName" type="text" name="name" placeholder="Name" />
              <input type="text" id="txtHp" />
              <div className="label">Email</div>
              <input
                id="txtEmail"
                type="text"
                name="email"
                placeholder="Email"
              />
              <div className="label">Contact Number</div>
              <input
                id="txtContactNo"
                type="text"
                name="phone"
                placeholder="Contact Number"
              />
              <div className="label">Message</div>
              <textarea id="txtMsg" name="message" rows="2"></textarea>
              <Buttons
                text="Send Message"
                color="secondary"
                type="submit"
                style={{
                  marginLeft: "auto",
                  marginTop: "2.5%",
                }}
              />
            </form>
          </div>
          <div className="col col-3">
            {/* <div className='label'>Social</div>
            <div className='text-icon'>
              <Facebook />
              <Twitter />
              <Instagram />
              <Youtube />
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};

const Affiliations = ({ args }) => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1025px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  return (
    <>
      {isMobile && (
        <div
          className="segment-4"
          style={{
            width: args.width,
          }}
        >
          <TitleBox title={"Affiliations"} />
          <div className="clients-box">
            <div className="clients-container cont-1">
              <img src={CLogo_1} alt="" />
              <div className="text">
                Philippine Association of Legitimate Contractors
              </div>
            </div>
            <div className="clients-container cont-2">
              <img src={CLogo_2} alt="" />
              <div className="text">Philippine Insurance Commission</div>
            </div>
            <div className="clients-container cont-4">
              <img src={CLogo_4} alt="" />
              <div className="text">Private Hospitals Association</div>
            </div>
            <div className="clients-container cont-5">
              <img src={CLogo_5} alt="" />
              <div className="text">
                Employers Confederation of the Philippines
              </div>
            </div>
          </div>
        </div>
      )}
      {isTablet && (
        <div
          className="segment-4"
          style={{
            width: args.width,
          }}
        >
          <TitleBox title={"Affiliations"} />
          <div className="clients-box">
            <div className="clients-container cont-1">
              <img src={CLogo_1} alt="" />
              <div className="text">
                Philippine Association of Legitimate Contractors
              </div>
            </div>
            <div className="clients-container cont-2">
              <img src={CLogo_2} alt="" />
              <div className="text">Philippine Insurance Commission</div>
            </div>
            <div className="clients-container cont-4">
              <img src={CLogo_4} alt="" />
              <div className="text">Private Hospitals Association</div>
            </div>
            <div className="clients-container cont-5">
              <img src={CLogo_5} alt="" />
              <div className="text">
                Employers Confederation of the Philippines
              </div>
            </div>
          </div>
        </div>
      )}
      {isDesktop && (
        <div
          className="segment-4"
          style={{
            height: args.height / 1.8,
            width: args.width,
          }}
        >
          <TitleBox title={"Affiliations"} />
          <div className="clients-box">
            <div className="clients-container cont-1">
              <img src={CLogo_1} alt="" />
              <div className="text">
                Philippine Association of Legitimate Contractors
              </div>
            </div>
            <div className="clients-container cont-2">
              <img src={CLogo_2} alt="" />
              <div className="text">Philippine Insurance Commission</div>
            </div>
            <div className="clients-container cont-4">
              <img src={CLogo_4} alt="" />
              <div className="text">Private Hospitals Association</div>
            </div>
            <div className="clients-container cont-5">
              <img src={CLogo_5} alt="" />
              <div className="text">
                Employers Confederation of the Philippines
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Home = ({ setActivateToast, setToastProps }) => {
  // Args

  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  return (
    <div className="home-container">
      <Hero args={{ height, width }} />
      <WhatWeOffer args={{ height, width }} />
      <News args={{ height, width }} />
      <Affiliations args={{ height, width }} />
      <ContactUs args={{ height, width, setActivateToast, setToastProps }} />
      <Footer args={{ height, width }} />
    </div>
  );
};

export default Home;
